<bulb-image [imageId]="imageId"
            [imageAsset]="imageAsset"
            [isEditingPage]="isEditingPage"
            [source]="'ckeditor'"
            [showPlaceholder]="showPlaceholder"
            (showCaption)="showCaption()"
            (resizeHandler)="resizeHandler($event.event, $event.imageId, $event.imageCreditId, $event.imageAsset)">
</bulb-image>
